import { config } from '../../appConfig'
import ChainFusionClient from '../../clients/ChainFusionClient'
import HyperLiquidClient from '../../clients/HyperLiquidClient'
import { ETH_COMISSION_WALLET, HYPERLIQUID_COMISSION } from '../../constants/business'
import { usePerpsSettings } from '../../state'
import useWallet from '../useWallet'

const useApproveBuilderFee = () => {
  const { wallet } = useWallet()
  const { hasApprovedBuilderFee, setHasApprovedBuilderFee } = usePerpsSettings()

  const approveBuilderFee = async () => {
    if (hasApprovedBuilderFee[wallet.principalId]) return

    const hyperliquidClient = new HyperLiquidClient()
    const { action, digest, nonce } = hyperliquidClient.prepareBuilderFeeApprove(
      ETH_COMISSION_WALLET,
      `${HYPERLIQUID_COMISSION}%`
    )

    const chainFusionClient = new ChainFusionClient(
      config.getAgent({ principalId: wallet.principalId })
    )

    const signature = await chainFusionClient.signEthHash(digest)

    if (!signature) throw 'Unable to sign builder fee approve'

    await hyperliquidClient.executeExchangeAction({
      action,
      signature,
      nonce,
    })
    setHasApprovedBuilderFee(wallet.principalId)
  }

  return { approveBuilderFee }
}

export default useApproveBuilderFee
